import AreaTemplate from '../AreaTemplate';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ElectricalContractor',
  name: 'Electrician Solutions Fresno — Reedley',
  description: 'Licensed electrician serving Reedley, CA. C-10 certified electrical contractor for residential and commercial electrical work in Reedley and South Fresno County.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Reedley',
    addressRegion: 'CA',
    postalCode: '93654',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: '36.5963', longitude: '-119.4501' },
  url: 'https://electriciansolutionsfresno.com/areas/reedley',
  telephone: '+1-559-123-4567',
  priceRange: '$$',
  areaServed: { '@type': 'City', name: 'Reedley', '@id': 'https://en.wikipedia.org/wiki/Reedley,_California' },
};

const faqs = [
  {
    q: 'Do you offer electrician services in Reedley, CA?',
    a: 'Yes! Electrician Solutions Fresno serves all of Reedley, CA — the World\'s Fruit Basket. Our C-10 licensed electricians handle residential and commercial electrical work, agricultural electrical systems, panel upgrades, and 24/7 emergency electrical services throughout Reedley and the Kings River corridor.',
  },
  {
    q: 'Do you handle packing house electrical work near Reedley?',
    a: 'Absolutely. Reedley is surrounded by fruit packing operations and we specialize in commercial refrigeration wiring, packing house electrical systems, cold storage circuits, and industrial three-phase power installations for the local food processing industry.',
  },
  {
    q: 'How quickly can you reach Reedley for electrical emergencies?',
    a: 'Reedley is approximately 30 miles south-east of Fresno. Our emergency electricians can typically reach Reedley in 45–70 minutes. We operate 24/7 for urgent electrical situations in Reedley and the surrounding Kings River valley.',
  },
  {
    q: 'Can you install solar systems for Reedley orchards and farms?',
    a: 'Yes. We handle the electrical work for solar installations on Reedley-area farms including panel upgrades, solar inverter wiring, battery storage, and interconnection to SCE and PG&E service in the area.',
  },
  {
    q: 'What areas near Reedley do you service?',
    a: 'We cover all of Reedley plus surrounding communities including Orange Cove, Dinuba, Parlier, Selma, and rural Fresno County properties along Manning Ave, Frankwood Ave, and the Kings River corridor.',
  },
  {
    q: 'Are you available for Mennonite community electrical work in the Reedley area?',
    a: 'Yes. We have extensive experience serving Reedley\'s diverse community including established Mennonite neighborhoods, new residential developments, and local businesses on G Street and Manning Ave.',
  },
];

const ReedleyPage = () => (
  <AreaTemplate
    area="Reedley"
    areaSlug="reedley"
    state="CA"
    county="Fresno County"
    population="27,000+"
    description="Electrician Solutions Fresno brings expert C-10 licensed electrical services to all of Reedley, CA — the World's Fruit Basket. Located along the beautiful Kings River in Southeast Fresno County, Reedley is home to a vibrant mix of residential neighborhoods, fruit packing operations, and agricultural businesses. Our certified Reedley electricians understand the unique electrical needs of this diverse community."
    neighborhoods={['Downtown Reedley', 'North Reedley', 'G Street Corridor', 'Manning Ave Area', 'Kings River Area', 'Frankwood Ave', 'East Reedley', 'Parlier Vicinity']}
    nearbyAreas={[
      { name: 'Sanger', slug: 'sanger' },
      { name: 'Selma', slug: 'selma' },
      { name: 'Dinuba', slug: 'dinuba' },
      { name: 'Fresno', slug: 'fresno' },
      { name: 'Visalia', slug: 'visalia' },
    ]}
    faqs={faqs}
    heroImage="https://public.readdy.ai/ai/img_res/26a06a93409c38a455bab9830c4d4dfa.jpg"
    heroImageAlt="Licensed Electrician in Reedley CA"
    teamImage="https://readdy.ai/api/search-image?query=Electrician%20team%20in%20branded%20uniforms%20posing%20in%20front%20of%20Reedley%20California%20orchard%20and%20Kings%20River%20landscape%20rows%20of%20citrus%20trees%20and%20stone%20fruit%20orchards%20blue%20sky%20showing%20expertise%20in%20agricultural%20community%20electrical%20work&width=800&height=600&seq=reedley_team_001&orientation=landscape"
    teamImageAlt="Electrician Solutions team serving Reedley CA"
    schema={schema}
  />
);

export default ReedleyPage;
